import React from 'react';
import clsx from 'clsx';
import styles from './index.module.scss';

export interface IOsPermissionModalProps {
  className?: string;
}

function IOsPermissionModal(props: IOsPermissionModalProps) {
  return (
    <div className={clsx(styles.root, props.className)}>
      <div className={styles.message}>
        “Safari” Would like to access the camera.
      </div>
      <div className={styles.buttons}>
        <div className={styles.btn1}>Don’t Allow</div>
        <div className={styles.btn2}>OK</div>
      </div>
    </div>
  );
}

export default IOsPermissionModal;
